import { initialProfileState, ProfileState } from 'mk2/apps/settings/containers/Profile/Profile.reducers';
import { AppState } from 'mk2/reducers';

export const getProfileState = (state: AppState, username: string): ProfileState =>
    state.containers.settings.settingsProfile[username] || initialProfileState;
